import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';

import * as discoverSelectors from '../../../Containers/Discover/discoverSelectors'

import {connect} from 'react-redux';
import {transformObjectToArray} from "../../../helpers/firebaseTransformations";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    listItem:{
        '&.active':{
            background:theme.palette.secondary.main
        },
        '&:hover':{
            background:theme.palette.secondary.main
        }
    },
    subList: {
        paddingLeft: theme.spacing(4),
        '& li':{
            background:'blue'
        }
    },
}));

interface Props {
    orderedDiscoverTop: any
    discoverOther: any;
    selectedDiscoverCard:any;
    setSelectedDiscoverCard:any;
}

function DiscoverList({orderedDiscoverTop, discoverOther = [], selectedDiscoverCard, setSelectedDiscoverCard}: Props) {
    const classes = useStyles();
    const [active, setActive] = React.useState(null)

    const handleDiscoverClick = ({id, location, parent}:any) =>{
        setActive(id)
        const loc = location === "top" ? "top" : "other";
        const idPath = parent ? parent + "/" + id : id;
        const path = loc + "/" + idPath;
        setSelectedDiscoverCard(path)
    }
    function createChildrenForTypeList(parent: any) {
        let discoverOtherRef = parent && parent.id ? discoverOther[parent.id] : null;
        if (!discoverOtherRef) return [];
        return transformObjectToArray(discoverOtherRef)
            .map(obj => {
                obj.parent_list = parent.id;
                // obj.title = generateContentForTitle(obj);
                if (obj.content.type === 'list') {
                    // let treeRef = parentTreeRef ? parentTreeRef.children.filter(child => child.id === obj.id)[0] : null; //Search within parent's children to find expanded value
                    // obj.expanded = treeRef ? treeRef.expanded : false;
                    obj.children = createChildrenForTypeList(obj);
                }

                return obj;
            })
            .sort((a, b) => a.index - b.index); //sorts children by their index value
    }


    const ListItemWrapper = ({obj}:any) => {
        return (
            <React.Fragment>
                <ListItem className={`${classes.listItem} ${obj.id === active ? "active" : ""}` } onClick={()=>handleDiscoverClick({id:obj.id, location:obj.location, parent:obj.parent_list})} button>
                    <ListItemText primary={obj.name}/>
                </ListItem>
                {obj.content.type === "list" && (
                    <Collapse in={true} timeout="auto" unmountOnExit>
                        <List className={classes.subList} component="div" >
                            {createChildrenForTypeList(obj).map(child => {
                                return (
                                    <ListItemWrapper obj={child}/>
                                )
                            })}

                        </List>
                    </Collapse>)}
            </React.Fragment>

        )
    }
return (
    <>
        <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
            <ListSubheader component="div" id="nested-list-subheader">
                <p>Select the discover card users will be taken to when they click on the push</p>
            </ListSubheader>
        }
        className={classes.root}
    >
        {orderedDiscoverTop.map((obj: any, index: number) => {


            return (
                <ListItemWrapper obj={obj}/>

            )
        })}

    </List>
        </>
);
}


function mapStateToProps(state:any)
    {
        return {
            activeDiscover: discoverSelectors.makeActiveDiscover(state),
            // activeDiscoverId: rootSelectors.selectActiveDiscoverId(state),
            discoverOther: discoverSelectors.selectDiscoverOther(state),
            expandedDiscoverNodes: state.ui.expandedDiscoverNodes,
            orderedDiscoverOther: discoverSelectors.selectOrderedDiscoverOtherArray(state),
            orderedDiscoverTop: discoverSelectors.selectOrderedDiscoverTopArray(state),
            topCommonBackgroundImageURL: state.discover.topCommonBackgroundImageURL,
        };
    }

const mapDispatchToProps =
    {

    }
;
export default connect(
mapStateToProps,
mapDispatchToProps,
)(DiscoverList);

